// extracted by mini-css-extract-plugin
module.exports = {"container":"AppActivity_container__3nBUC","spinnerContainer":"AppActivity_spinnerContainer__3VUbS","spinner":"AppActivity_spinner__ikZ9-"};